type InterviewConfigLike = {
  status?: string | null;
  questions_json?: unknown;
};

export function hasPublishedInterviewQuestions(config: InterviewConfigLike | null | undefined): boolean {
  return !!(
    config &&
    config.status === 'published' &&
    Array.isArray(config.questions_json) &&
    config.questions_json.length > 0
  );
}

export function readyInterviewJobIds<T extends InterviewConfigLike & { job_id?: string | null }>(
  configs: T[] | null | undefined,
): Set<string> {
  return new Set(
    (configs ?? [])
      .filter(hasPublishedInterviewQuestions)
      .map((config) => config.job_id)
      .filter((jobId): jobId is string => typeof jobId === 'string' && jobId.length > 0),
  );
}
